import React from 'react';
import { colors } from '@/theme/colors';
import { cn } from '@/shadcn-ui/utils';

interface ArrowRightProps {
  className?: string;
  fill?: string;
}

const ArrowRight: React.FC<ArrowRightProps> = ({ className, fill = colors.neutral1 }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.29302 17.7071C8.90249 17.3166 8.90249 16.6834 9.29302 16.2929L13.5859 12L9.29301 7.70711C8.90249 7.31658 8.90249 6.68342 9.29301 6.29289C9.68354 5.90237 10.3167 5.90237 10.7072 6.29289L15.7072 11.2929C16.0978 11.6834 16.0978 12.3166 15.7072 12.7071L10.7072 17.7071C10.3167 18.0976 9.68354 18.0976 9.29302 17.7071Z"
        fill={fill}
      />
    </svg>
  );
};

export default ArrowRight;
